import { Link } from "react-router-dom";
import { Cancel, Href, PrintInvoice } from "../../../../../constants";
import { routes } from "../../../../../routers/routes";

// This component provides buttons for printing an invoice and canceling the action.
export const InvoiceButtons = () => {

  const handlePrint = () => {
    window.print()
  }

  return (
    <span className="custom-print-btn pb-5" >
      <Link onClick={() => handlePrint()} className="print-btn"   to={Href}>
        {PrintInvoice}
        <i className="icon-arrow-right"  />
      </Link>
      <Link className="cancel-btn" to={routes.ECommerce.Product} download>
        {Cancel}
        <i className="icon-arrow-right"  />
      </Link> 
    </span>
  );
};